<template>
  <!-- overflow-x-clip, not -hidden: `hidden` turns this div into a scroll
       container, which silently disables every `position: sticky` below it
       (the site header, the live-session header). -->
  <div class="bg-surface-0 flex min-h-screen flex-col overflow-x-clip">
    <Toast position="top-center" :append-to="appendTarget" />
    <ConfirmDialog :append-to="appendTarget" dismissable-mask />

    <template v-if="route.meta.layout !== false">
      <AnnouncementBar />
      <Header />
      <main class="flex-1">
        <RouterView :key="$route.fullPath" />
      </main>
      <Footer v-if="!route.meta.hideFooter" />
    </template>
    <template v-else>
      <RouterView :key="$route.fullPath" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useEventListener } from '@vueuse/core';
import { ConfirmDialog, Toast } from 'primevue';
import { computed, ref, watch } from 'vue';
import { RouterView, useRoute } from 'vue-router';

import AnnouncementBar from '@/components/AnnouncementBar.vue';
import Footer from '@/components/Layout/Footer.vue';
import Header from '@/components/Layout/Header.vue';

const route = useRoute();

const isFullscreen = ref(false);

const appendTarget = computed(() => {
  return isFullscreen.value ? document.fullscreenElement : document.body;
});

useEventListener(document, 'fullscreenchange', () => {
  isFullscreen.value = !!document.fullscreenElement;
});

// Reset closed announcements when visiting home page
watch(
  () => route.path,
  (newPath) => {
    if (newPath === '/') {
      localStorage.removeItem('closedAnnouncements');
      // Trigger a custom event to notify AnnouncementBar
      window.dispatchEvent(new CustomEvent('resetAnnouncements'));
    }
  },
  { immediate: true } // Run immediately for page refresh
);
</script>

<style>
/* Turnstile styles can be added here if needed */
</style>
